import * as React from "react";
import { FormField, Required, Size } from "../../index";
import { createStyles, makeStyles, Theme } from "@material-ui/core";

interface LabelProps {
  field: FormField;
  withRequiredSuffix?: true;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    fullWidthLabel: {
      fontWeight: "bold",
      marginLeft: theme.spacing(1) * 5,
      textAlign: "left",
      alignSelf: "center"
    },
    gridLabel: {
      fontWeight: "bold",
      padding: theme.spacing(1) * 3,
      textAlign: "right",
      alignSelf: "center",
      minHeight: 70
    }
  })
);

export function getTitle(field: FormField): string {
  if (!field.title) {
    return field.name;
  }

  return field.title;
}

export const LabelTitle = (props: LabelProps) => {
  const { field } = props;
  let requiredSuffix = "";
  if (props.withRequiredSuffix) {
    requiredSuffix = field.type.validators.indexOf(Required) > -1 ? " *" : "";
  }

  return <>{getTitle(field) + requiredSuffix}</>;
};

export const Label = (props: LabelProps) => {
  const { field } = props;
  const classes = useStyles();

  return (
    <label
      className={
        field.renderSize === Size.BIG
          ? classes.fullWidthLabel
          : classes.gridLabel
      }
    >
      <LabelTitle field={field} withRequiredSuffix={true} />
    </label>
  );
};
